import { render, staticRenderFns } from "./EstudianteImportCursos.vue?vue&type=template&id=20804d71&scoped=true"
import script from "./EstudianteImportCursos.vue?vue&type=script&lang=js"
export * from "./EstudianteImportCursos.vue?vue&type=script&lang=js"
import style0 from "./EstudianteImportCursos.vue?vue&type=style&index=0&id=20804d71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20804d71",
  null
  
)

export default component.exports